export class VerifyB2BConnectionDto {
  type: string;
  key: string;

  constructor(type: string, key: string) {
    this.type = type;
    this.key = key;
  }
}
